import React, { FC, useEffect } from "react";
import "./App.css";

//middleware
import { useDispatch, useSelector } from "react-redux";
import { verify } from "jsonwebtoken";
import { Router, Switch, Route } from "react-router-dom";

//interfaces
import { IStore } from "./interfaces/IStore";
import { IUser } from "./interfaces/IUser";

//aux
import history from "./utils/history";
import { SetUserAction } from "./redux/actions";
import { jwtPassword } from "./utils/constants";

//views
import Login from "./views/Unlogged/Login/Login";
import { userRoles } from "./utils/roles";
import LoggedRoutes from "./routes";

const App: FC = () => {
  let { token } = useSelector(({ user }: IStore) => user as IUser);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) {
      const localStorageToken = localStorage.getItem("token");
      localStorageToken && resetUser(localStorageToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const resetUser = (localStorageToken: string) => {
    try {
      //if token exists and is valid
      const {
        userId,
        staffId,
        userRoleId,
        investigatorRoleId,
        name,
        surname1,
        surname2,
        username,
        email,
        phone,
      }: any = verify(localStorageToken, jwtPassword);
      dispatch(
        SetUserAction({
          token: localStorageToken,
          userId,
          staffId,
          userRoleId,
          investigatorRoleId,
          isAdmin: userRoleId === userRoles.admin,
          name,
          surname1,
          surname2,
          username,
          email,
          phone,
        })
      );
    } catch {
      //if token was fiddled with
      localStorage.removeItem("token");
      history.push("/");
    }
  };

  return (
    <Router history={history}>
      <div className="d-flex" id="wrapper">
        <Switch>
          {!token && <Route exact path="/" component={Login} />}
          {token && <LoggedRoutes />}
        </Switch>
      </div>
    </Router>
  );
};

export default App;
